export default __webpack_public_path__ + "static/media/book_int_who_is_storyteller.1cb8919a.mp3";